import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import SafariParkViewDetails from "./SafariParkViewDetails";
import { useParksViewContext } from "provider/ParkViewProvider";
import SafariParkSearch from "components/Home/SafariParkSearch";
import { useParams } from "react-router-dom";
import apiCall from "components/Api/api";
import { useMobileVerifyContext } from "provider/MobileVerificationProvider";
import MobileNoVerificationModal from "components/common/mobilenoverification/MobileNoVerificationModal";

const SafariParkView = () => {

  return (
    <SafariParkViewContent />
  );
};


const SafariParkViewContent = () => {
  const { parkSlug } = useParams();
  const { parksViewDispatch } = useParksViewContext();
  // const { toggleMobileVerify } = useMobileVerifyContext();

  useEffect(() => {
    const fetchParkDetail = async () => {
      try {
        parksViewDispatch({ type: "SET_PARK_VIEW_LOADING", payload: true });

        const [
          parkViewRes,
          parkQouteOptionResponse,
        ] = await Promise.allSettled([
          apiCall({ url: `park/${parkSlug}`, method: "GET" }),
          apiCall({ url: `park/${parkSlug}/park-stay-category?pageSize=20`, method: "GET" })
        ])


        if (parkViewRes?.status === "fulfilled" && parkViewRes?.value?.status === 200) {
          if (parkViewRes?.value?.data?.errors) {
            console.error("API returned errors:", parkViewRes?.value?.data.errors);
            // Optionally dispatch error to state or show a toast
            parksViewDispatch({ type: "SET_PARKS_VIEW_ERROR", payload: parkViewRes?.value?.data.errors });
          } else {
            const data = parkViewRes?.value?.data?.data;
            parksViewDispatch({ type: "SET_PARKS_VIEW_DETAILS", payload: data });
          }


        } else {
          console.error(`Unexpected response status: ${parkViewRes?.value?.status}`);
          // Optionally dispatch a generic error
          parksViewDispatch({ type: "SET_PARKS_VIEW_ERROR", payload: "Failed to fetch park details." });
        }
        if (parkQouteOptionResponse?.status === "fulfilled" && parkQouteOptionResponse?.value?.status === 200) {
          if (parkQouteOptionResponse?.value?.data?.errors) {
            console.error("API returned errors:", parkQouteOptionResponse?.value?.data.errors);
            // Optionally dispatch error to state or show a toast
            parksViewDispatch({ type: "SET_PARKS_VIEW_ERROR", payload: parkQouteOptionResponse?.value?.data.errors });
          } else {
            const data = parkQouteOptionResponse?.value?.data?.stay_category_options?.data;
            const options = data.map((item) => ({
              label: item.title,
              value: item.id,
            }));

            parksViewDispatch({ type: "SET_PARKS_ACCOM_OPTIONS", payload: options });
          }
        } else {
          console.error(`Unexpected response status: ${parkViewRes?.value?.status}`);
          // Optionally dispatch a generic error
          parksViewDispatch({ type: "SET_PARKS_VIEW_ERROR", payload: "Failed to fetch park details." });
        }
      } catch (error) {
        console.error("Park detail fetch error:", error);
        // Optionally dispatch network error
        parksViewDispatch({ type: "SET_PARKS_VIEW_ERROR", payload: "Network error occurred." });
        parksViewDispatch({ type: "SET_PARK_VIEW_LOADING", payload: false });
      } finally {
        parksViewDispatch({ type: "SET_PARK_VIEW_LOADING", payload: false });
      }
    };

    if (parkSlug) {
      fetchParkDetail();
    }
  }, [parkSlug]);

  return (
    <>
      <section className="banner_section-inner position-relative">
        <picture className="position-relative">
          <source
            srcSet={"/img/baneer1719164625.jpg"}
            media="(max-width:576px)"
            type="image/jpg"
          />
          <img
            src="/img/baneer1719164625.jpg"
            className="d-block w-100 banner_search"
            alt="banner"
            type="image/jpg"
            loading="lazy"
          />
        </picture>
        <div className="banner_searchBox">
          <Container fluid="lg">
            <Row>
              <Col className="pt-2">
                <div className="tab-block" id="tab-block">
                  <div className="tab-cont">
                    <div className="tab-pane">
                      <SafariParkSearch />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      <SafariParkViewDetails />
      {/* {toggleMobileVerify && <MobileNoVerificationModal />} */}
    </>
  );
}

export default SafariParkView;
